import clsx from 'clsx';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';

import Checkbox from '../../Checkbox/Checkbox';
import Sort from '../Sort/Sort';

const CheckboxFilterBox = (props) => {
  const [searchValue, setSearchValue] = useState(null);
  const [searchedFilterOptions, setSearchedFilterOptions] = useState([]);

  const debouncedHandleSearch = _.debounce((searchValue) => {
    const { filterOptions, onSearchFilters } = props;
    setSearchValue(searchValue);
    setSearchedFilterOptions(
      filterOptions.filter((f) => f.label.toLowerCase().includes(searchValue))
    );
    if (onSearchFilters) {
      onSearchFilters(searchValue);
    }
  }, 400);

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    debouncedHandleSearch(searchValue);
  };

  useEffect(() => {
    return debouncedHandleSearch.cancel;
  }, [debouncedHandleSearch]);

  const {
    column,
    filterOptions,
    filterSelected,
    isSearchable = false,
    classes = {},
    excludeFilter,
    sortingType,
    sortingSelected,
    onUpdateSorting,
    onUpdateFilters,
    disableFilters,
    hideFilterSection = false,
    selectAllLabel,
    bottomContent,
    isForcedChecked = false,
  } = props;

  const options = searchValue ? searchedFilterOptions : filterOptions;
  const isAllOptionVisible = !searchValue;

  let isCheckedAll =
    filterSelected && filterSelected.filter((f) => f.isActive).length === options.length;
  if (excludeFilter) {
    isCheckedAll =
      filterSelected &&
      filterSelected.filter((f) => f.isActive && f.id !== excludeFilter).length > 0 &&
      filterSelected.filter((f) => f.isActive && f.id !== excludeFilter).length ===
        options.filter((f) => f.id !== excludeFilter).length;
  }

  const isFilterChecked = (value) => {
    if (filterSelected) {
      const index = filterSelected.map((f) => f.id).indexOf(value);
      if (index > -1) {
        return filterSelected[index].isActive;
      }
    }
    return false;
  };

  const handleSelectAll = () => {
    if (isCheckedAll) {
      onUpdateFilters(filterSelected.map((f) => ({ ...f, isActive: false })));
    } else if (!isCheckedAll) {
      onUpdateFilters(filterSelected.map((f) => ({ ...f, isActive: true })));
    }
  };

  const handleSelectFilters = (value) => {
    if (isFilterChecked(value)) {
      onUpdateFilters([
        ...(filterSelected || []).map((f) => {
          if (f.id === value) {
            return { ...f, isActive: false };
          }
          return f;
        }),
      ]);
    } else {
      onUpdateFilters([
        ...(filterSelected || []).map((f) => {
          if (f.id === value) {
            return { ...f, isActive: true };
          }
          return f;
        }),
      ]);
    }
  };

  return (
    <div className={clsx(`filterBoxContainer`, classes.options)}>
      {column.sorting && (
        <Sort
          column={column}
          sortingType={sortingType}
          sortingSelected={sortingSelected}
          onUpdateSorting={onUpdateSorting}
        />
      )}
      {!hideFilterSection && (
        <div className={clsx(`filterByContainer`, classes.filterBy)}>
          <h4>Filter By</h4>
          {isSearchable && (
            <div className="searchItems">
              <input type="text" placeholder="Search" onChange={handleSearch} />
              <i className="material-icons">search</i>
            </div>
          )}
          <div className="filterItems">
            {searchValue && searchedFilterOptions.length < 1 && (
              <div className="filterItem no-results-found">No Results Found</div>
            )}
            {isAllOptionVisible && (
              <div className={clsx(`filterItem`, disableFilters && 'disabled')}>
                <div className="filterCheckbox">
                  <Checkbox
                    value="all"
                    onChange={handleSelectAll}
                    checked={isCheckedAll || isForcedChecked}
                  />
                  <span>{selectAllLabel ? selectAllLabel : 'All'}</span>
                </div>
              </div>
            )}

            {options.length > 0 &&
              options.map((filter) => {
                return (
                  <div
                    key={`filterItemKey_${filter.id}`}
                    className={clsx(`filterItem`, filter.class, disableFilters && 'disabled')}
                  >
                    <div className="filterCheckbox">
                      <Checkbox
                        value={filter.id}
                        onChange={handleSelectFilters}
                        checked={isForcedChecked ? true : isFilterChecked(filter.id)}
                      />
                      <span>{filter.label}</span>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
      <div className="bottomContent">{bottomContent}</div>
    </div>
  );
};

export { CheckboxFilterBox };
